import createCookie from '../createCookie';
import storageAvailable from '../storageAvailable';
/**
 *
 * Stores a value in storage. Defaults to looking in localStorage, but can be changed via function params. Will fallback to using cookies if localStorage or sessionStorage are not available.
 *
 * ```js
 * import { setStorage } from '@minerva-analytics/pantheon';
 *
 * setStorage({ key: `thing`, value: `saveWhereYouCan` })
 * setStorage({ key: `thing`, value: `saveWhereYouCanForThisSession`, session: true })
 * setStorage({ key: `thing`, value: `saveWhereYouCanInCookies`, forceCookies: true })
 * ```
 *
 *
 * @param {Object} options The options for the function
 * @param {string} options.key The key to store the value under
 * @param {[type]} options.value The value to store
 * @param {Boolean} options.session Should the value be stored in sessionStorage?
 * @param {Boolean} options.forceCookies Should the value be stored in cookies?
 *
 */

var setStorage = function setStorage(_ref) {
  var key = _ref.key,
      value = _ref.value,
      _ref$session = _ref.session,
      session = _ref$session === void 0 ? false : _ref$session,
      _ref$forceCookies = _ref.forceCookies,
      forceCookies = _ref$forceCookies === void 0 ? false : _ref$forceCookies;
  var windowStorage = session ? "sessionStorage" : "localStorage";
  var useCookies = forceCookies || !storageAvailable(windowStorage);

  if (typeof value !== "undefined" && value !== null) {
    var sValue = value;

    if (typeof value === "object") {
      sValue = JSON.stringify(value);
    }

    if (useCookies) {
      createCookie(key, sValue, !session ? 365 : null);
    } else {
      window[windowStorage].setItem(key, sValue);
    }
  }
};

export default setStorage;